import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AssociationService, ToastrService } from './../../../../shared/index';
@Component({
    selector: 'staged-tab',
    templateUrl: './staged-tab.html',
    standalone: false
})
/** staged-tab component*/
export class StagedTabComponent {
    public companyvisible = true;
    public minesitevisible = true;
    public equipmentvisible = true;
    @Input('Is_Project_Selected') Is_Project_Selected = false;
    private subscriptions: Subscription[] = [];

    constructor(
        private _associationService: AssociationService,
        private _toastrService: ToastrService
    ) {
      }
    public cdkDropEventTriggered(value: any): void {
        if ($(value[2]).data('company-id') && $(value[1]).data('minesite-id')) {
            if (Number(localStorage.getItem('Lock')) === 1) {
                this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
                return;
            }
            this._associationService.associateMinesiteToCompany($(value[2]).data('company-id'), $(value[1]).data('minesite-id'), false);
        }
        else if ($(value[2]).data('minesite-id') && $(value[1]).data('equipment-id')) {
            if (Number(localStorage.getItem('Lock')) === 1) {
                this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
                return;
            }
            this._associationService.associateEquipmentToMinesite($(value[2]).data('minesite-id'), $(value[1]).data('equipment-id'));
        }
    }
}
